import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import WorkspaceFormInput from 'workspace/WorkspaceFormInput'
import { changeFormData } from 'workspace/actions'

const WorkspaceFormBatchNumber = ({ batchNumber, onChange }) => (
  <WorkspaceFormInput attribute='batchNumber'>
    <input
      type='text'
      className='workspace-form__input'
      value={(batchNumber || '')}
      onChange={(e) => onChange({ batchNumber: e.target.value ? e.target.value : null })}
    />
  </WorkspaceFormInput>
)

WorkspaceFormBatchNumber.propTypes = {
  batchNumber: PropTypes.string,
  onChange: PropTypes.func.isRequired
}

const mapStateToProps = (state) => ({
  batchNumber: state.form.data.batchNumber
})

const mapDispatchToProps = ({
  onChange: changeFormData
})

export default connect(mapStateToProps, mapDispatchToProps)(WorkspaceFormBatchNumber)
